// extracted by mini-css-extract-plugin
export default {"rozet":"FNZaKml7IrRCsb5461RK","rozetSvg":"lzSAk02DF9owSLoNLw8V"};